import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  text: {
    textAlign: 'right',
    flex: 1
  }
});

class MenuItemDetailPrice extends React.Component {
  static propTypes = {
    cost: PropTypes.string,
    classes: PropTypes.object
  };

  render() {
    const { cost, classes } = this.props;
    return (
      <Typography
        data-testid="price-preview"
        variant="h4"
        className={classes.text}
        component="span"
      >{`$${cost}`}</Typography>
    );
  }
}

export default withStyles(styles)(MenuItemDetailPrice);
